import CustomButton from "@components/buttons/CustomButton";
import GlobalTextInputField from "@components/inputs/GlobalTextInputField";
import SlidingPanel from "@components/sliders/SlidingPanel";
import { groupManagementApi } from "@services/apis/GroupManagement";
import {
  AddMemberToGroupRequest,
  AddMemberToGroupResponse,
} from "@services/models/Groups/AddMemberToGroup";
import React, { useState } from "react";
import useSnackbarMessage from "../../../utils/HandleSuccessErrorSnackbars";

interface AddMerchantToGroupSliderProps {
  isOpen: boolean;
  onClose: () => void;
  onMerchantAdded?: () => void;
  selectedGroupId: string | null;
  selectedGroupName: string | null;
}

const AddMerchantToGroupSlider: React.FC<AddMerchantToGroupSliderProps> = ({
  isOpen,
  onClose,
  onMerchantAdded,
  selectedGroupId,
  selectedGroupName,
}) => {
  const [merchantId, setMerchantId] = useState<string>("");
  const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false);
  const { handleError, handleSuccess } = useSnackbarMessage();

  const checkValidInput = () => {
    const merchantIdNum = parseInt(merchantId.trim());
    return (
      merchantId.trim().length > 0 &&
      !isNaN(merchantIdNum) &&
      merchantIdNum > 0 &&
      selectedGroupId !== null
    );
  };

  const handleSubmit = async () => {
    if (!selectedGroupId) {
      handleError({ message: "Please select a group first" });
      return;
    }

    try {
      setIsButtonLoading(true);
      const addMemberRequest: AddMemberToGroupRequest = {
        groupId: parseInt(selectedGroupId),
        memberId: parseInt(merchantId.trim()),
        roleType: "merchant",
      };
      const response: AddMemberToGroupResponse =
        await groupManagementApi.addMemberToGroup(addMemberRequest);
      handleSuccess({
        message: response.msg || "Merchant added to group successfully",
      });
      setMerchantId("");
      onMerchantAdded?.();
      onClose();
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.msg ||
        "Adding merchant to group failed. Please try again.";
      handleError({ message: errorMessage });
    } finally {
      setIsButtonLoading(false);
    }
  };

  return (
    <SlidingPanel
      isOpen={isOpen}
      heading={`Add Merchant to Group ${
        selectedGroupName ? `(${selectedGroupName})` : ""
      }`}
      onClose={onClose}
      onClickCross={onClose}
      showConfirm={false}
    >
      <div className="flex flex-col px-[16px] py-[16px] gap-4">
        <GlobalTextInputField
          placeholder="Enter merchant ID"
          value={merchantId}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setMerchantId(e.target.value)
          }
          title="Enter the merchant ID to add to the group."
        />
        <div className="my-4">
          <CustomButton
            text="ADD MERCHANT"
            onClick={handleSubmit}
            isActive={checkValidInput()}
            isButtonLoading={isButtonLoading}
          />
        </div>
      </div>
    </SlidingPanel>
  );
};

export default AddMerchantToGroupSlider;
